<template>
    <section>
        <div v-if="placedOrder" class="cabinet-content-wrap">
            <header
                class="cabinet-header flex flex-align-center justify-content-between"
            >
                <h1 class="h1 v2-retailer-title">Ваш заказ отправлен!</h1>
            </header>

            <div class="v2-retailer-cart__placed">
                <div class="mb-3">
                    Мы отправили каждому поставщику письмо с изделиями, которые
                    вы хотите заказать. Также мы указали в письме ваши
                    контактные данные, ч тобы поставщик мог с вами связаться.
                </div>
                <router-link
                    :to="`/account/orders/${placedOrder.OrderID}`"
                    class="cabinet-link"
                >
                    Перейти к заказу
                </router-link>
            </div>
        </div>

        <div v-else-if="error">
            <div class="error text-center">
                <div class="error-image">
                    <img src="/img/icons/error.svg" alt="" />
                </div>
                <div class="error-title">
                    Упс! Что-то пошло не так.
                </div>
                <div class="error-button">
                    <button type="button" class="cabinet-btn" @click="getCart">
                        Попробовать еще раз
                    </button>
                </div>
            </div>
        </div>

        <div v-else-if="cartIsEmpty" class="cabinet-content-wrap">
            <header
                class="cabinet-header flex flex-align-center justify-content-between"
            >
                <h1 class="h1 v2-retailer-title">Корзина пуста</h1>
            </header>

            <div class="v2-retailer-cart__top">
                <div class="v2-retailer-cart__top-total">
                    Здесь пока ничего нет
                </div>
                <router-link
                    :to="{ name: 'RetailerCatalog' }"
                    class="v2-retailer-cart__top-link"
                >
                    Продолжить покупки
                </router-link>
            </div>
        </div>

        <div v-else class="cabinet-content-wrap">
            <header
                class="cabinet-header flex flex-align-center justify-content-between"
            >
                <h1 class="h1 v2-retailer-title">Заказ</h1>
                <button
                    v-if="cartCount"
                    type="button"
                    class="cabinet-btn-icon cabinet-btn-icon--small cabinet-btn-icon--trash-grey d-md-none"
                    @click="openModal('ClearCart')"
                ></button>
            </header>

            <div class="v2-retailer-cart__top">
                <div class="v2-retailer-cart__top-total">
                    {{ cartCount }} изделий от {{ cartGroupsCount }} брендов
                </div>
                <div
                    v-if="cartCount"
                    class="v2-retailer-cart__top-delete "
                    @click="openModal('ClearCart')"
                >
                    Удалить все
                </div>
            </div>

            <section class="v2-retailer-cart__content">
                <div class="v2-retailer-cart__content-left">
                    <cart-list
                        @onChangeItem="changeCartItem"
                        @onRemoveItem="removeItem"
                    />

                    <div class="v2-retailer-cart__customer js-customer">
                        <div class="v2-retailer-cart__customer-title">
                            Покупатель
                        </div>
                        <form>
                            <div class="cabinet-form-group">
                                <label
                                    class="cabinet-form-group__label required"
                                    for="name"
                                    >Имя</label
                                >
                                <input
                                    id="name"
                                    v-model="form.name"
                                    type="text"
                                    class="cabinet-form-group__input"
                                    :class="{ error: errors.includes('name') }"
                                    @input="onChangeField('name')"
                                />
                            </div>

                            <div class="cabinet-form-group">
                                <label
                                    class="cabinet-form-group__label required"
                                    for="phone"
                                    >Номер телефона</label
                                >
                                <input
                                    id="phone"
                                    v-model="form.phone"
                                    type="text"
                                    class="cabinet-form-group__input"
                                    :class="{ error: errors.includes('phone') }"
                                    @input="onChangeField('phone')"
                                />
                            </div>

                            <div class="cabinet-form-group">
                                <label
                                    class="cabinet-form-group__label required"
                                    for="email"
                                    >Электронная почта</label
                                >
                                <input
                                    id="email"
                                    v-model="form.email"
                                    type="text"
                                    class="cabinet-form-group__input"
                                    :class="{ error: errors.includes('email') }"
                                    @input="onChangeField('email')"
                                />
                            </div>

                            <div class="cabinet-form-group">
                                <label class="cabinet-form-group__label"
                                    >Юридическое лицо</label
                                >
                                {{ user.company_name }}
                            </div>
                        </form>
                    </div>
                </div>
                <div class="v2-retailer-cart__content-right">
                    <div
                        class="v2-retailer-cart__total js-sticky-total"
                        data-margin-top="32px"
                    >
                        <div class="v2-retailer-cart__total-title">
                            Итого
                            <span
                                >~
                                {{ getFormattedNum(cartTotalSum.toFixed(2)) }}
                                Р</span
                            >
                        </div>
                        <div class="v2-retailer-cart__info">
                            Сумма заказа является примерной. Точную сумму
                            уточняйте у поставщика.
                        </div>
                        <div class="v2-retailer-cart__total-section">
                            <div class="v2-retailer-cart__total-subtitle">
                                Ваш заказ
                            </div>
                            <div
                                v-for="group in cartGroups"
                                :key="group.BrandID"
                                class="v2-retailer-cart__total-descr"
                                @click="scrollToEl('js-brand-' + group.BrandID)"
                            >
                                {{ brandName(group.BrandID) }},
                                {{ getCartCountByBrand(group.BrandID) }} шт,
                                {{
                                    getFormattedNum(
                                        getCartSumByBrand(
                                            group.BrandID
                                        ).toFixed(2)
                                    )
                                }}
                                Р
                            </div>
                        </div>
                        <div class="v2-retailer-cart__total-section">
                            <div class="v2-retailer-cart__total-subtitle">
                                Покупатель
                            </div>
                            <div
                                class="v2-retailer-cart__total-descr"
                                data-target="js-customer"
                                @click="scrollToEl('js-customer')"
                            >
                                {{ customerInfo }}
                            </div>
                            <div
                                class="v2-retailer-cart__total-descr v2-retailer-cart__total-descr--gray"
                            >
                                {{ user.company_name }}
                            </div>
                        </div>
                        <div class="v2-retailer-cart__total-agreement">
                            <label class="cabinet-cart-checkbox">
                                <input
                                    v-model="form.acceptRules"
                                    type="checkbox"
                                    @change="onChangeField('acceptRules')"
                                />
                                <span
                                    class="cabinet-cart-checkbox__checkmark"
                                ></span>
                                Я согласен с
                                <a
                                    href="https://docs.goldnet.market/doku.php?id=user_agreement"
                                    target="_blank"
                                    class="cabinet-form-info__link"
                                    >Правилами площадки</a
                                >
                                <div
                                    v-if="errors.includes('acceptRules')"
                                    class="error-label"
                                >
                                    Необходимо согласиться с правилами
                                </div>
                            </label>
                        </div>
                        <button
                            type="button"
                            class="cabinet-btn cabinet-btn--big cabinet-btn--input-w"
                            :class="{ loading: submitting }"
                            @click="sendOrder"
                        >
                            Отправить заказ
                        </button>
                        <div class="v2-retailer-cart__info mt-4">
                            Всем поставщикам будут отправлены письма с вашими
                            заказами. Дальнейшая работа по заказам будет
                            происходить напрямую с поставщиком, без участия
                            площадки.
                        </div>
                    </div>
                </div>
            </section>

            <clear-cart-modal
                :is-open="isClearCartModalOpened"
                @onConfirm="onConfirmClearCart"
                @onClose="closeModal('ClearCart')"
            />
        </div>
    </section>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import modal from '@/mixins/modal'
import base from '@/mixins/base'
import getFormattedNum from '@/utils/getFormattedNum'
import CartList from '@/components/Cabinet/Cart/List'
import ClearCartModal from '@/components/Cabinet/Cart/ClearCartModal'

import Sticky from 'sticky-js'

export default {
    name: 'RetailerCart',
    components: {
        ClearCartModal,
        CartList
    },
    mixins: [modal, base],
    data() {
        return {
            isCartLoading: false,
            submitting: false,
            isClearCartModalOpened: false,
            placedOrder: null,
            form: {
                name: '',
                phone: '',
                email: '',
                acceptRules: false
            },
            formLoading: false,
            errors: []
        }
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('cart', ['cartGroups']),
        ...mapGetters('cart', [
            'error',
            'cartIsEmpty',
            'cartCount',
            'cartGroupsCount',
            'cartTotalCount',
            'cartTotalSum',
            'cartCountByBrand',
            'cartSumByBrand'
        ]),
        ...mapGetters('retailerBrand', ['brandName']),
        customerInfo() {
            return [this.form.name, this.form.phone, this.form.email]
                .filter(item => item)
                .join(', ')
        }
    },
    mounted() {
        this.initSticky()

        this.setUserFields()
    },
    methods: {
        ...mapActions('cart', [
            'getCart',
            'clearCart',
            'changeItemQuantity',
            'deleteFromCart'
        ]),
        ...mapActions('orders', ['createOrder']),
        getFormattedNum,
        initSticky() {
            this.$nextTick(() => {
                var stickyTotal
                if (window.$(window).width() >= 1024) {
                    stickyTotal = new Sticky('.js-sticky-total')
                }
                window.$(window).on('resize', function() {
                    if (window.$(window).width() >= 1024) {
                        if (!stickyTotal) {
                            stickyTotal = new Sticky('.js-sticky-total')
                        }
                    } else {
                        if (stickyTotal) {
                            stickyTotal.destroy()
                            stickyTotal = null
                        }
                    }
                })
            })
        },
        getCartCountByBrand(brandId) {
            return this.cartCountByBrand(brandId)
        },
        getCartSumByBrand(brandId) {
            return this.cartSumByBrand(brandId)
        },
        setUserFields() {
            this.form.name = this.user.name
            this.form.phone = this.user.phone
            this.form.email = this.user.Email
        },
        onConfirmClearCart() {
            this.$Progress.start()

            this.clearCart()
                .then(() => {
                    this.getCart()
                })
                .finally(() => {
                    this.$Progress.finish()
                    this.closeModal('ClearCart')
                })
        },
        changeCartItem({ productID, quantity, comment }) {
            this.isCartLoading = true

            this.changeItemQuantity({
                productID,
                quantity,
                comment
            })
                .then(() => {
                    this.getCart()
                })
                .finally(() => {
                    this.isCartLoading = false
                })
        },
        removeItem(productID) {
            this.$Progress.start()

            this.deleteFromCart(productID)
                .then(() => {
                    this.$notify({
                        type: 'default',
                        title: 'Изделие удалено из корзины'
                    })

                    this.getCart()
                })
                .finally(() => {
                    this.$Progress.finish()
                })
        },
        sendOrder() {
            const errors = []
            this.errors = []

            for (const field in this.form) {
                if (field === 'acceptRules') {
                    if (!this.form[field]) {
                        errors.push(field)
                    }

                    continue
                }

                if (this.form[field] === '') {
                    errors.push(field)
                }
            }

            if (errors.length > 0) {
                this.errors = errors
                return
            }

            if (this.submitting) return

            this.submitting = true

            this.$Progress.start()

            this.createOrder({
                Name: this.form.name,
                Phone: this.form.phone,
                Email: this.form.email
            })
                .then(order => {
                    this.placedOrder = order
                    this.scrollTop()
                })
                .finally(() => {
                    this.submitting = false
                    this.$Progress.finish()
                })
        },
        onChangeField(name) {
            const index = this.errors.indexOf(name)

            if (index !== -1) {
                this.errors.splice(index, 1)
            }
        }
    }
}
</script>
